/**
 * Quién puede entrar a cada ruta. Fuente única de verdad.
 *
 * Antes esto estaba en dos sitios que no coincidían: el guard del router miraba
 * `meta.requiresPermission` y el menú del layout hacía su propia comprobación a
 * mano. De ahí salían dos fallos concretos:
 *
 *  - "Editar reviews" aparecía en el menú a cualquier usuario autenticado, pero
 *    la ruta exige el permiso `view reviews`: al pulsarlo te echaba a inicio sin
 *    decir nada.
 *  - "Usuarios" y "Roles" se mostraban también a quien tuviera el rol admin,
 *    pero el guard solo aceptaba el permiso, con el mismo resultado.
 *
 * Ahora el menú y el guard llaman a la misma función, así que es imposible que
 * se muestre algo a lo que no se puede entrar.
 */

/** El rol admin entra a todo; se decide aquí y en ningún otro sitio. */
export const SUPER_ROLE = 'admin'

export function canAccessRoute(route, auth) {
  const meta = route?.meta ?? {}

  if (meta.requiresAuth && !auth.isAuthenticated) return false
  if (!meta.requiresPermission) return true
  if (auth.hasRole(SUPER_ROLE)) return true

  const required = meta.requiresPermission
  return Array.isArray(required) ? auth.hasAnyPermission(required) : auth.hasPermission(required)
}

/** Motivo del rechazo, para poder avisar en lugar de redirigir en silencio. */
export function accessDenialReason(route, auth) {
  const meta = route?.meta ?? {}
  if (meta.requiresAuth && !auth.isAuthenticated) return 'unauthenticated'
  if (!canAccessRoute(route, auth)) return 'forbidden'
  return null
}
